import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FsAxonService } from '@lib/axon/services/axon.service';

const ECOM_PERMISSION_NAME_MAP = {
  'admin.fusus': 'User Administration',
  'alpr.readrecord.any.list': 'Read/Hit Record Search',
  'axon_aware.self.locate': 'View map',
};

@Component({
  selector: 'fs-axon-managed-permission-message',
  templateUrl: './axon-managed-permission-message.component.html',
  styleUrls: ['./axon-managed-permission-message.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf],
})
export class AxonManagedPermissionMessageComponent {
  constructor(private readonly _axonService: FsAxonService) {}

  @Input() externalRef: string;
  @Input() isExternallyManaged: boolean;
  @Input() canEditPermissions: boolean;
  @Input() canEditMembers: boolean;
  @Input() groupName: string;

  public get shouldShowExternalManagementMessage(): boolean {
    return (
      this.isExternallyManaged &&
      ECOM_PERMISSION_NAME_MAP[this.externalRef] &&
      !this.canEditPermissions &&
      !this.canEditMembers
    );
  }

  public get shouldShowPermissionExternalManagementMessage(): boolean {
    return this.isExternallyManaged && !this.canEditPermissions && this.canEditMembers;
  }

  public get shouldShowMemberExternalManagementMessage(): boolean {
    return this.isExternallyManaged && this.canEditPermissions && !this.canEditMembers;
  }

  public get permissionNameInEcom(): string {
    return ECOM_PERMISSION_NAME_MAP[this.externalRef];
  }

  public get ecomAdminLink(): string {
    return new URL('/axon/admin/roles', this._axonService.orgSpecificBaseUrl).href;
  }

  public get ecomGroupLink(): string {
    const params = new URLSearchParams({
      name: this.groupName || '',
    });
    return new URL(
      `/axon/admin/group-search?${params.toString()}`,
      this._axonService.orgSpecificBaseUrl,
    ).href;
  }
}
